<template>
    <div class="offlineSignIn" id="barId">
      <div class="text1">预约报名线下培训</div>
        <div class="whiteBlock">
            <div class="whiteText2">填写报名信息</div>
            <div class="whiteText4">报名吉林一号遥感开发者培训班</div>
            <v-select class="area1" style="top: 220px;" v-model="currentQs" :items="campOptions" :item-text="(o)=>o.regionStatus" :item-value="(o)=>o.qs" placeholder="请选择培训地点" label="培训地点 *" outlined :rules="[rules.notNull]"></v-select>
            <v-text-field class="area1" style="top:299px;" v-model="nameUser" placeholder="" label="姓名 *" outlined :rules="[rules.notNull]"></v-text-field>
            <v-text-field class="area1" style="top:381px;" v-model="ageUser" placeholder="" label="年龄 *" outlined :rules="[rules.ageJudge]"></v-text-field>
            <v-select class="area1" style="top: 460px;" v-model="educationUser" placeholder="" :items="educationList" label="学历 *" outlined :rules="[rules.notNull]"></v-select>
            <v-text-field class="area1" style="top: 539px;" v-model="companyUser" placeholder="" label="单位/机构 *" outlined :rules="[rules.notNull]"></v-text-field>
            <!-- <v-select v-model="sexUser" class="area1" style="top: 381px;" :items="sexList" label="性别" placeholder=" " outlined :rules="[rules.notNull]"></v-select> -->
            <v-text-field class="area1" style="top: 618px;" v-model="occupation" placeholder=""  label="职业 *" outlined :rules="[rules.notNull]"></v-text-field>
            <v-text-field class="area1" style="top: 697px;" v-model="emailUser" placeholder="" label="邮箱 *" outlined :rules="[rules.emialNumber]"></v-text-field>
            <v-text-field class="area1" style="top: 776px;" v-model="majorUser" placeholder="" label="专业/兴趣方向 *" outlined :rules="[rules.notNull]"></v-text-field>
            <div class="button" v-if="!signInPermit">申请报名</div>
            <div class="button-s" v-if="signInPermit" @click="signInSuccess()">申请报名</div>
        </div>
        <div v-if="showFailDialog" class="failMask" @click="closeFailDialog()">
          <div class="failDialog">
            <div class="failTitle">提示</div>
            <div class="failContent">{{ failMsg }}</div>
            <div class="failBtn" @click="closeFailDialog()">知道了</div>
          </div>
        </div>

    </div>
</template>

<script>
import {rootUrl} from '@/globalConfig'
import { resolveCurrentQs } from '@/utils/campPicker'
  export default {
    name: "offlineSignIn",
    data() {
      return {
        trainCampList:[],
        trainDetailItem:{},
        campOptions:[],
        currentQs:null,
        nameUser: "",
        companyUser:"",
        sexUser:"",
        sexList:["男","女"],
        ageUser:"",
        educationUser:"",
        emailUser:"",
        majorUser:"",
        educationList:["高中","专科","本科","硕士研究生","博士研究生","博士后"],
        occupation:'',
        rules: {
            notNull: (value) => {
                if (value == "" || value == null) {
                    return "此项不能为空";
                } else {
                    return true;
                }
            },
            emialNumber: (value) => /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(value) || "邮箱不合法",
            ageJudge: (value) => {
                if(!isNaN(parseFloat(value)) && isFinite(value)){
                    if(value>=0&&value<=100){
                        return true;
                    }else{
                        return "年龄输入不合法";
                    }
                }else{
                    return "年龄输入不合法";
                }
                
            }
        },
        signInPermit:false,
        connectStatus:false,
        count:0,
        showFailDialog:false,
        failMsg:'',

      }
    },
    methods: {
      getKey() {
        return localStorage.getItem("token");
      },
       //带权限判断的跳转
      jumpWithPermission(type,path,fromUrl){
        //path:需要跳转到的路由；fromUrl：如果权限不满足，满足后回跳的路由
        //注意：fromUrl必须为包含本项目router中base的相对地址，如商城个人中心为：/store/UserCenter
        let loginUserId=localStorage.getItem('userId');//是否已登录
        let authentication=localStorage.getItem('authentication');//0:已实名；1：未实名
        if(type=='可游客'){
          if(fromUrl){
            window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
          }
          else {
            window.open(rootUrl+path,"_self")
          }
        }else if(type=='仅登录'){
          //已登录
          if(loginUserId){
            if(fromUrl){
              window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
            }
            else {
              window.open(rootUrl+path,"_self")
            }
          }
          //未登录
          else {
            if(fromUrl){
              window.open(rootUrl+'/Login'+"?fromUrl="+rootUrl+fromUrl,"_self")
            }
            else {
              window.open(rootUrl+'/Login',"_self")
            }
          }
        }else if(type=='仅实名'){
          //已登录
          if(loginUserId){
            //已实名
            if(authentication=='0'){
              if(fromUrl){
                window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
              }
              else {
                window.open(rootUrl+path,"_self")
              }
            }
            //未实名
            else {
              window.open(rootUrl+'/Authentication',"_self")
            }

          }
          //未登录
          else {

            if(fromUrl){
              window.open(rootUrl+'/Login'+"?fromUrl="+rootUrl+fromUrl,"_self")
            }
            else {
              window.open(rootUrl+'/Login',"_self")
            }
          }
        }
      },
       //实名权限检查与处理（培训班版）
      checkAndHandleAuthentication(){
          console.log("进入实名检查")
          let loginUserId=localStorage.getItem('userId');//是否已登录
          let authentication=localStorage.getItem('authentication');//0:已实名；1：未实名
          console.log(loginUserId,authentication)
          console.log(localStorage.getItem('preRoute'))
          if(!loginUserId){
            this.jumpWithPermission('仅登录','/Login','/learn/signInContent')
          }
          else if(authentication!='0'){
            this.jumpWithPermission('仅实名','/Authentication','/learn/signInContent')
        }
        return true;
      },
      getCampList(){
        this.axios.get("/learn_back/course/register/getCampList", {
          headers: {
            Authorization: "Bearer " + this.getKey(),
          },
        })
        .then((res) => {
          this.campOptions = res.data.data.trainCampList || [];
          this.currentQs = resolveCurrentQs(this.campOptions, this.$route && this.$route.query ? this.$route.query.qs : undefined);
        })
      },
      getRegisterCache(){
        this.axios.get("/learn_back/course/register/getRegisterCache", {
          headers: {
            Authorization: "Bearer " + this.getKey(),
          },
        })
        .then((res) => {
          if(res.data.data.name!=null&&res.data.data.name!=''){
            this.nameUser=res.data.data.name
          }
          if(res.data.data.company!=null&&res.data.data.company!=''){
            this.companyUser=res.data.data.company
          }
          if(res.data.data.occupation!=null&&res.data.data.occupation!=''){
            this.occupation=res.data.data.occupation
          }
          if(res.data.data.age!=null&&res.data.data.age!=''){
            this.ageUser=res.data.data.age
          }
          if(res.data.data.email!=null&&res.data.data.email!=''){
            this.emailUser=res.data.data.email
          }
          if(res.data.data.education!=null&&res.data.data.education!=''){
            this.educationUser=res.data.data.education
          }
          if(res.data.data.major!=null&&res.data.data.major!=''){
            this.majorUser=res.data.data.major
          }
        })
      },
      submitOk(){
          let myreg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
          if(this.currentQs!=null
          &&this.nameUser!=null&&this.nameUser!=""&&this.companyUser!=null&&this.companyUser!=""
          &&this.occupation!=null&&this.occupation!=""
          &&this.ageUser!=null&&this.ageUser!=""
          &&this.educationUser!=null&&this.educationUser!=""
          &&this.emailUser!=null&&this.emailUser!=""
          &&myreg.test(this.emailUser)
          &&this.majorUser!=null&&this.majorUser!=""){
              this.signInPermit=true
          }else{
              this.signInPermit=false
          }
      },
      signInSuccess(){
        var userInfo = {
            "age":this.ageUser,
            "company":this.companyUser,
            "occupation":this.occupation,
            "major":this.majorUser,
            "education":this.educationUser,
            "email":this.emailUser,
            "qs":this.currentQs
        }
        this.axios.post("/learn_back/course/register/saveTrainCampRegister",userInfo,
          {
            headers: {
              Authorization: "Bearer " + this.getKey(),
            },
          }
        )
        .then((res) => {
          if(res.data.msg=='报名成功'){
            this.$router.push('/offlineSignInResult')
          }else{
            this.failMsg = (res.data && res.data.msg) || '报名失败'
            this.showFailDialog = true
          }
        })
      },
      closeFailDialog(){
        this.showFailDialog = false
      },
    },
  
    mounted() {
      let authentication=localStorage.getItem('authentication');//0:已实名；1：未实名
      if(authentication!='0'){
        this.$router.push('/')
      }
    document.getElementById('barId').scrollIntoView({ behavior: "instant"});

        if (localStorage.getItem('authentication')==0) {
            //提交按钮控制
            this.$nextTick(() => {
              setInterval(this.submitOk, 200);
            })
        }
        this.getCampList()
        this.getRegisterCache()
    }
  }
</script>

<style scoped>
.offlineSignIn{
    position: relative;
    width: 100%;
    height: auto;
    background: #F5F5F6;
    overflow: hidden;
}
.text1{
    position: relative;
    margin-top: 126px;
    margin-left: calc(50% - 200px);
    width: 400px;
    height: 26px;
    font-family: Tensentype-ZhiHeiJ-W4, Tensentype-ZhiHeiJ;
    font-weight: normal;
    font-size: 26px;
    color: #3A3A3A;
    line-height: 26px;
    text-align: center;
}
.whiteBlock{
    position: relative;
    margin-top: 50px;
    margin-left: calc(50% - 640px);
    width: 1280px;
    height: 1010px;
    background: #FFFFFF;
    box-shadow: 0px 5px 10px 0px rgba(0,0,0,0.05);
    border-radius: 16px;
    margin-bottom: 150px;
}
.whiteText1{
    position: absolute;
    top: 75px;
    left: calc(50% - 200px);
    width: 400px;
    height: 26px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 24px;
    color: #979797;
    line-height: 26px;
    text-align: center;
}
.whiteText2{
    position: absolute;
    top: 80px;
    left: calc(50% - 640px);
    width: 1280px;
height: 22px;
font-family: PingFangSC, PingFang SC;
font-weight: 600;
font-size: 20px;
color: #979797;
line-height: 22px;
text-align: center;
}
.whiteLine1{
    position: absolute;
    top: 193px;
    left: calc(50% - 480px);
    width: 960px;
    height: 1px;
    border-top: 1px solid #CCCCCC;
}
.greyBlock{
    position: absolute;
    top: 219px;
    left: calc(50% - 480px);
    width: 960px;
    height: 680px;
    overflow-x: hidden;
    overflow-y: auto;
}
.greyList{
    position: relative;
    margin-left: 0;
    margin-bottom: 15px;
    width: 960px;
    height: 100px;
    background: linear-gradient( 180deg, #F6F6F6 0%, #EAEAEA 100%);
    border-radius: 16px;  
}
.listText1{
    position: absolute;
    top: 25px;
    left: 50px;
    width: auto;
    height: 22px;
    font-family: PingFangSC, PingFang SC;
    font-weight: normal;
    font-size: 20px;
    color: #3A3A3A;
    line-height: 22px;
}
.listText2{
    position: absolute;
    top: 62px;
    left: 50px;
    width: auto;
    height: 16px;
font-family: PingFangSC, PingFang SC;
font-weight: normal;
font-size: 16px;
color: #979797;
line-height: 16px;
}
.listText3{
    position: absolute;
    top: 39px;
    left: 680px;
    width: auto;
    height: 16px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #979797;
    line-height: 16px;
}
.listText4{
    position: absolute;
top: 39px;
left: 833px;
    width: 82px;
height: 16px;
font-family: PingFangSC, PingFang SC;
font-weight: 600;
font-size: 16px;
color: #979797;
line-height: 16px;
text-align: center;
}
.gobackImg{
    position: absolute;
    top: 70px;
    left: 100px;
    width: 20px;
    height: 20px;
    background-image: url('../assets/Home/灰色返回.png');
    background-size: 100% 100%;
    cursor: pointer;
    transition: 0.3s;
}
.gobackImg:hover{
    background-image: url('../assets/Home/金色返回.png');
    background-size: 100% 100%;
}
.whiteText3{
    position: absolute;
    top: 70px;
    left: 130px;
    width: 80px;
    height: 20px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #3A3A3A;
    line-height: 20px;
    cursor: pointer;
}
.whiteText4{
    position: absolute;
    top: 130px;
    left: calc(50% - 640px);
    width: 1280px;
    height: 18px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 300;
    font-size: 16px;
    color: #3A3A3A;
    line-height: 18px;
    text-align: center;
}
.area1{
  position: absolute;
  top: 220px;
  left: calc(50% - 250px);
  width: 500px;
height:55px;
background: rgba(0,0,0,0.05);
border-radius: 8px;
}
.button{
    position: absolute;
    top: 850px;
    left: 565px;
    width: 150px;
    height: 44px;
    background: #CCCCCC;
    border-radius: 22px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #FFFFFF;
    line-height: 44px;
    text-align: center;
}
.button-s{
    position: absolute;
    top: 850px;
    left: 565px;
    width: 150px;
    height: 44px;
    background: #C49760;
    border-radius: 22px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #FFFFFF;
    line-height: 44px;
    text-align: center;
    cursor: pointer;
}
</style>
<style scoped>
.signInShadow{
  position: fixed;
  top: 0;
  width: 100%;
  height:100%;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 10000;
}
.dialog2 {
    position: absolute;
    width: 800px;
    height: 400px;
    border-radius: 16px;
    left: calc(50% - 400px);
    top: calc(50% - 200px);
    z-index: 10001;
    background: #ffffff;
}
.dialogImg1{
    position: absolute;
    top: 0;
    right: -50px;
    cursor: pointer;
}
.shadowText1{
    position: absolute;
    top: 50px;
    width: 800px;
    height: 28px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 20px;
    color: #3A3A3A;
    line-height: 28px;
    text-align: center;
}
.shadowText2{
    position: absolute;
    top: 118px;
    left: 128px;
    width: 544px;
    height: 90px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #3A3A3A;
    line-height: 30px;
    text-align: justify;
    text-indent: 2em;
}
.shadowButton1{
    position: absolute;
    top: 305px;
    left: 243px;
    width: 150px;
    height: 44px;
    background: #C49760;
    border-radius: 22px;
    border: 1px solid #C49760;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 16px;
    color: #FFFFFF;
    line-height: 44px;
    text-align: center;
    cursor: pointer;
}
.shadowButton2{
    position: absolute;
    top: 305px;
    left: 408px;
    width: 150px;
    height: 44px;
    background: #FFFFFF;
    border-radius: 22px;
    border: 1px solid #C49760;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 16px;
    color: #C49760;
    line-height: 44px;
    text-align: center;
    cursor: pointer;
}
</style>
<style scoped>
.failMask{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 10000;
}
.failDialog{
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 420px;
  background: #FFFFFF;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.15);
}
.failTitle{
  height: 56px;
  line-height: 56px;
  text-align: center;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 18px;
  color: #3A3A3A;
  border-bottom: 1px solid #EEEEEE;
}
.failContent{
  padding: 32px 40px;
  text-align: center;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 15px;
  color: #3A3A3A;
  line-height: 26px;
}
.failBtn{
  margin: 0 auto 28px;
  width: 120px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: #C49760;
  border-radius: 20px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 15px;
  color: #FFFFFF;
  cursor: pointer;
}
.failBtn:hover{
  background: #b3864e;
}
</style>